import { Box, Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { userQuery } from '../../../core/authentication/queries';
import { organizationQuery } from '../../../core/organization/queries';
import { projectSectionsQuery, selectedProjectSectionsQuery } from '../../../core/project/queries';
import { useAppSelector } from '../../../types';
import { formatDistance } from '../../../utils/numbers';
import { Header } from '../../design_system/page/Header';
import { theme } from '../../legacy/style/theme';
import { OrganizationName, SessionUsername, Title } from '../../session/list-sessions/styles';
import { ActionsOnSelectedProjectSections } from './ActionsOnSelectedProjectSections';
import { ProjectSelectorActions } from './ProjectSelectorActions';

export const ProjectHeader = () => {
    const { t } = useTranslation();
    const organization = useAppSelector(organizationQuery);
    const user = useAppSelector(userQuery);
    const projectSections = useAppSelector(projectSectionsQuery);
    const selectedProjectSections = useAppSelector(selectedProjectSectionsQuery);
    const { count, totalDistance } = useMemo(() => {
        const meters = selectedProjectSections.reduce(
            (sum, projectSection) => sum + (projectSection.cumulEnd - projectSection.cumulStart),
            0,
        );

        return { count: selectedProjectSections.length, totalDistance: formatDistance(meters) };
    }, [selectedProjectSections]);

    return (
        <>
            <Grid container spacing={2}>
                <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100px' }} xs={3}>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Title>{t('projectList.yourProject')}</Title>
                        <ProjectSelectorActions />
                    </Box>

                    {projectSections && count > 0 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', mt: '-24px' }}>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '18px', fontWeight: 600 }}>
                                {t('projectList.selectedSections', { count })}
                            </Typography>
                            <Typography sx={{ color: theme.color.blue.primary3, fontSize: '14px', fontWeight: 500 }}>
                                {t('projectList.totalDistance', { totalDistance })}
                            </Typography>
                        </Box>
                    )}
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Header />
                </Grid>
                <Grid
                    item
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'end',
                        mt: '24px',
                        paddingRight: '6px',
                    }}
                    xs={3}
                >
                    <SessionUsername>
                        {user?.lastName} {user?.firstName}
                    </SessionUsername>
                    <OrganizationName>{organization?.name}</OrganizationName>
                </Grid>
            </Grid>
            <ActionsOnSelectedProjectSections />
        </>
    );
};
